module.exports = __webpack_public_path__ + "img/lupa.e5b052a7.svg";